<template>
    <rkm-area title="Anotações de enfermagem">
        <template slot="trailing">
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                v-rkm-tooltip.hover
                title="Adicionar anotação de enfermagem"
                small
                :hidden="hidden"
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List :data="data" />

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true },
        hidden: { type: Boolean, default: false },
    },
}
</script>